// extracted by mini-css-extract-plugin
export var box = "_9r-1";
export var checked = "_9r-2";
export var descriptionSpacer = "_9r-9";
export var disabled = "_9r-3";
export var icon = "_9r-6";
export var input = "_9r-0";
export var labelSpacer = "_9r-8";
export var medium = "_9r-5";
export var small = "_9r-4";
export var text = "_9r-7";